import { defineNuxtPlugin } from "nuxt/app";
import { library, config } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

// FontAwesome icon sets
import {
  faAngleDown,
  faAngleLeft,
  faAngleRight,
  faAngleUp,
  faArrowRightToBracket,
  faBan,
  faCaretDown,
  faCaretUp,
  faCheck,
  faChevronDown as fasChevronDown,
  faChevronLeft,
  faChevronRight,
  faChevronUp as fasChevronUp,
  faCircle,
  faCircleCheck,
  faDash,
  faDownLeftAndUpRightToCenter,
  faEllipsis,
  faFileLines,
  faHome,
  faInfo,
  faLinkSimple,
  faMagnifyingGlass,
  faRectangleVertical,
  faSearch,
  faSlidersUp,
  faSort,
  faSortDown,
  faSortUp,
  faSquare as fasSquare,
  faTimes,
  faTrashCan,
  faUpRightAndDownLeftFromCenter,
  faUserGroup,
  faXmarkLarge,
  faImage,
  faCirclePlus,
  faPencil,
  faTrash,
  faTriangleExclamation,
  faCircleSmall,
  faXmark as fasXmark,
  faPlus as fasPlus,
  faTimesCircle as fasTimesCircle,
  faPhotoFilm,
  faCircleInfo as fasCircleInfo,
  faSignalStream as fasSignalStream,
  faPodcast,
} from "@fortawesome/pro-solid-svg-icons"; // fas
import {
  faArrowDown,
  faArrowDownArrowUp,
  faArrowDownToLine,
  faArrowLeft,
  faArrowRight,
  faArrowRotateRight,
  faArrowUp,
  faArrowUpWideShort,
  faBarsProgress,
  faBullhorn,
  faCalendarDays,
  faCalendarRange,
  faChartBar,
  faChartColumn,
  faChartLine,
  faChartPie,
  faChartScatterBubble,
  faChevronDown,
  faChevronUp,
  faCircleCheck as farCircleCheck,
  faCircleInfo,
  faCircleExclamation,
  faCircleMinus,
  faCirclesOverlap,
  faComputer,
  faEnvelope,
  faEquals,
  faEye,
  faEyeSlash,
  faFileChartColumn,
  faFileChartPie,
  faFrown,
  faGlobe,
  faGripLines,
  faInfoCircle,
  faKeySkeleton,
  faList,
  faMeh,
  faMinusCircle,
  faNewspaper,
  faObjectExclude,
  faPen as farPen,
  faPenToSquare,
  faPlus,
  faRadio,
  faShapes,
  faSmile,
  faSquare as farSquare,
  faTrashCan as farTrashCan,
  faTv,
  faTvRetro,
  faShareNodes,
  faUnlockKeyhole,
  faLockKeyhole,
  faCircleXmark,
  faXmark,
  faArrowLeft as farArrowLeft,
  faArrowRight as farArrowRight,
  faTriangleExclamation as farTriangleExclamation,
  faGripDots as farGripDots,
  faArrowsRotate as farArrowRotate,
  faAddressBook,
  faClock,
  faPodcast as farPodcast,
  faArrowUpRightFromSquare,
  faGem,
} from "@fortawesome/pro-regular-svg-icons"; // far
import {
  faAngleLeft as falAngleLeft,
  faAngleRight as falAngleRight,
  faBookUser,
  faCircleQuestion,
  faCog,
  faFileChartLine,
  faPen,
  faSignOut,
  faSliders,
  faTimesCircle,
  faUserChart,
  faPenToSquare as falPenToSquare,
  faTrashCan as falTrashCan,
  faPhotoFilm as faPhotoFilmLight,
} from "@fortawesome/pro-light-svg-icons"; // fal
import {
  faTwitter,
  faXTwitter,
  faFacebook,
  faInstagram,
  faLinkedin,
  faTiktok,
  faYoutube,
  faGoogle,
} from "@fortawesome/free-brands-svg-icons";
import { mediaLink } from "@/icons/media-link";

// Disable auto CSS addition by Nuxt
config.autoAddCss = false;

// Add all icons to the library
library.add(
  // Light icons (fal)
  // @ts-ignore
  falAngleLeft,
  falAngleRight,
  falPenToSquare,
  falTrashCan,
  faBookUser,
  faCircleQuestion,
  faCog,
  faFileChartLine,
  faPen,
  faSignOut,
  faSliders,
  faTimesCircle,
  faUserChart,
  faPhotoFilmLight,

  // Solid icons (fas)
  faAngleDown,
  faAngleLeft,
  faAngleRight,
  faAngleUp,
  faArrowRightToBracket,
  faBan,
  faCaretDown,
  faCaretUp,
  faCheck,
  fasChevronDown,
  faChevronLeft,
  faChevronRight,
  fasChevronUp,
  faCircle,
  faCircleCheck,
  faDash,
  faDownLeftAndUpRightToCenter,
  faEllipsis,
  faFileLines,
  faHome,
  faInfo,
  faLinkSimple,
  faMagnifyingGlass,
  faRectangleVertical,
  faSearch,
  faSlidersUp,
  faSort,
  faSortDown,
  faSortUp,
  fasSquare,
  faTimes,
  faTrashCan,
  faUpRightAndDownLeftFromCenter,
  faUserGroup,
  faXmarkLarge,
  fasXmark,
  faImage,
  faCirclePlus,
  faPencil,
  faTrash,
  faTriangleExclamation,
  faCircleSmall,
  fasPlus,
  faAddressBook,
  fasTimesCircle,
  faPhotoFilm,
  fasCircleInfo,
  faPodcast,
  fasSignalStream,

  // Regular icons (far)
  faArrowDown,
  faArrowDownArrowUp,
  faArrowDownToLine,
  faArrowLeft,
  faArrowRight,
  faArrowRotateRight,
  faArrowUp,
  faArrowUpWideShort,
  faBarsProgress,
  faBullhorn,
  faCalendarDays,
  faCalendarRange,
  faChartBar,
  faChartColumn,
  faChartLine,
  faChartPie,
  faChartScatterBubble,
  faChevronDown,
  faChevronUp,
  farCircleCheck,
  faCircleInfo,
  faCircleExclamation,
  faCircleMinus,
  faCirclesOverlap,
  faComputer,
  faEnvelope,
  faEquals,
  faEye,
  faEyeSlash,
  faFileChartColumn,
  faFileChartPie,
  faFrown,
  faGlobe,
  faGripLines,
  faInfoCircle,
  faKeySkeleton,
  faList,
  faMeh,
  faMinusCircle,
  faNewspaper,
  faObjectExclude,
  farPen,
  faPenToSquare,
  faPlus,
  faRadio,
  faShapes,
  faSmile,
  farSquare,
  farTrashCan,
  faTv,
  faTvRetro,
  faShareNodes,
  faUnlockKeyhole,
  faLockKeyhole,
  faCircleXmark,
  faXmark,
  farArrowLeft,
  farArrowRight,
  farTriangleExclamation,
  farGripDots,
  farArrowRotate,
  faClock,
  faArrowUpRightFromSquare,
  faGem,

  farPodcast,

  // Brand icons
  faTwitter,
  faXTwitter,
  faFacebook,
  faInstagram,
  faLinkedin,
  faTiktok,
  faYoutube,
  faGoogle,

  // Custom icons
  mediaLink,
);

// Register FontAwesome component globally
export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.component("font-awesome-icon", FontAwesomeIcon);
});
